import React, { useState, useEffect } from 'react';
import { createExpense, fetchExpenseCategories } from '../utils/api';

const CreateExpenseModal = ({ show, onClose, onExpenseCreated }) => {
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [amount, setAmount] = useState('');
    const [date, setDate] = useState(new Date().toISOString().split('T')[0]);
    const [expenseCategoryId, setExpenseCategoryId] = useState('');
    const [categories, setCategories] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (show) {
            const getCategories = async () => {
                try {
                    const fetchedCategories = await fetchExpenseCategories();
                    setCategories(fetchedCategories || []);
                    if (fetchedCategories.length > 0) {
                        setExpenseCategoryId(fetchedCategories[0].id);
                    }
                } catch (error) {
                    setError(error.message);
                }
            };
            getCategories();
        }
    }, [show]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        const expenseData = {
            name,
            amount: Math.round(parseFloat(amount) * 100),
            date,
            expense_category_id: parseInt(expenseCategoryId, 10),
        };

        if (description) {
            expenseData.description = description;
        }

        try {
            await createExpense(expenseData);
            onExpenseCreated();
            onClose();
        } catch (error) {
            setError(error.message);
        } finally {
            setLoading(false);
        }
    };

    if (!show) {
        return null;
    }

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h2>Create Expense</h2>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <input
                            type="text"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            required
                            placeholder='Name'
                        />
                    </div>
                    <div className="form-group">
                        <textarea
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            placeholder='Description (Optional)'
                        />
                    </div>
                    <div className="form-group">
                        <input
                            type="number"
                            step="0.01"
                            value={amount}
                            onChange={(e) => setAmount(e.target.value)}
                            required
                            placeholder='Amount'
                        />
                    </div>
                    <div className="form-group">
                        <input
                            type="date"
                            value={date}
                            onChange={(e) => setDate(e.target.value)}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <select
                            value={expenseCategoryId}
                            onChange={(e) => setExpenseCategoryId(e.target.value)}
                            required
                        >
                            <option value="">Select Category</option>
                            {categories.map((category) => (
                                <option key={category.id} value={category.id}>
                                    {category.name}
                                </option>
                            ))}
                        </select>
                    </div>
                    {error && <p className="error-message">{error}</p>}
                    <div className="actions-centered">
                        <button type="button" onClick={onClose} disabled={loading} className='cancel-button text-button'>Cancel</button>
                        <button type="submit" disabled={loading} className='submit-button text-button'>{loading ? 'Creating...' : 'Create'}</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default CreateExpenseModal;
